module.exports = __webpack_public_path__ + "img/ronin.1288659f.png";